import React, { FunctionComponent, useState } from 'react';

import { Divider } from '../../organisms/ProductCard/styles';
import Font from '../Font';
import Icon from '../Icon';
import {
  AccordionDescription,
  AccordionItemWrapper,
  AccordionItemWrapperContent
} from './styles';

export type AccordionItemProps = {
  description?: string;
  label: React.ReactNode;
};

const Accordion: FunctionComponent<AccordionItemProps> = ({
  description,
  label
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <AccordionItemWrapperContent data-testid="accordion-element">
      <AccordionItemWrapper
        $clickable={Boolean(description)}
        data-testid="accordion-clickable"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Font customConfiguration={{ fontWeight: 700 }} variant="bodyRegular">
          {label}
        </Font>
        {description && (
          <Icon
            data-testid="accordion-icon"
            iconColor="brand2"
            iconName={isOpen ? 'InterfaceChevronUp' : 'InterfaceChevronDown'}
          />
        )}
      </AccordionItemWrapper>
      {isOpen && description && (
        <AccordionDescription data-testid="accordion-description">
          <Font
            dangerouslySetInnerHTML={{ __html: description }}
            variant="bodyRegular"
          />
        </AccordionDescription>
      )}
      <Divider />
    </AccordionItemWrapperContent>
  );
};

export default Accordion;
